import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H4 } from 'UIComponents/elements/headings';
import H1 from 'UIComponents/elements/headings/H1';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledH4 = styled(H4).withConfig({
  displayName: "CoreSeatsExplainerModal__StyledH4",
  componentId: "sxlcbl-0"
})(["margin-top:16px;margin-bottom:2px;"]);
const CoreSeatsExplainerModal = ({
  handleModalClose,
  currencyCode,
  coreSeatProPrice
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 600,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleModalClose
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.title'
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.description'
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left m-top-8",
        children: [/*#__PURE__*/_jsx(StyledH4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.whatIsACoreSeat.title'
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.whatIsACoreSeat.description'
          })
        }), /*#__PURE__*/_jsx(StyledH4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.howAreCoreSeatsPriced.title'
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: 'upgrades.coreSeatsExplainerModal.howAreCoreSeatsPriced.description_jsx',
            elements: {
              FormattedCurrency
            },
            options: {
              value: coreSeatProPrice,
              currencyCode
            }
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: handleModalClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.close'
        })
      })
    })]
  });
};
export default CoreSeatsExplainerModal;